import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { isBoostPlayerBonus, safeNumber, conditionalValue } from "../../helpers";
const bonusTypes = ["PROFIT_BOOST", "ODDS_BOOST_PERCENTAGE", "QUALIFYING_BET", "GUARANTEED_PAYOUT"];
function isGuaranteedPayoutPending(playerBonus) {
    return (playerBonus === null || playerBonus === void 0 ? void 0 : playerBonus.type) === "GUARANTEED_PAYOUT" && playerBonus.boostStatus === "GuaranteedPayoutPending";
}
function isGuaranteedPayoutWon(playerBonus) {
    return (playerBonus === null || playerBonus === void 0 ? void 0 : playerBonus.type) === "GUARANTEED_PAYOUT" && playerBonus.boostStatus === "GuaranteedPayoutWon";
}
function shouldUseBonusReturns(playerBonus, boostPercentage, betStatus) {
    if (isGuaranteedPayoutWon(playerBonus)) {
        return true;
    }
    if (bonusTypes.includes(getTruthyValue(playerBonus === null || playerBonus === void 0 ? void 0 : playerBonus.type, ""))
        && !boostPercentage) {
        return false;
    }
    return isBoostPlayerBonus(playerBonus) && playerBonus.status === "Active" && betStatus !== "CashOut";
}
export function parseBetReturns({ bet, playerBonus, boostPercentage, dictionary, formatAmount, }) {
    const potentialReturns = shouldUseBonusReturns(playerBonus, boostPercentage, bet.settlementStatus)
        ? playerBonus.maxWinningAmount
        : bet.potentialReturns;
    const returns = shouldUseBonusReturns(playerBonus, boostPercentage, bet.settlementStatus)
        ? playerBonus.winningsAmount
        : bet.returns;
    if (bet.settlementStatus === "Open" || isGuaranteedPayoutPending(playerBonus)) {
        const title = bet.type === "ProgressiveParlay" ? dictionary.myBetsDictionary.ToPayUp : dictionary.myBetsDictionary.ToPay;
        return formatAmount(potentialReturns, `${title}${dictionary.myBetsDictionary.AmountDisplayString}`);
    }
    const returnLabel = conditionalValue(bet.earlyExitStatus === "Full", dictionary.myBetsDictionary.Returned, dictionary.myBetsDictionary.Paid);
    return formatAmount(safeNumber(returns), `${returnLabel}${dictionary.myBetsDictionary.AmountDisplayString}`);
}
//# sourceMappingURL=parseBetReturns.js.map